<template>
    <a class="wrapper" target="_blank" :href="`https://reddit.com${post.permalink}`">
        <div class="score">{{post.score}}</div>
        <div class="body">
            <div class="title">{{post.title}}</div>
            <div class="poster">
                Posted
                <a target="_blank" :href="`https://reddit.com/u/${post.author}`">{{post.author}} </a>
                by in
                <a target="_blank" :href="`https://reddit.com/r/${post.subreddit}`">{{post.subreddit}}</a>
            </div>
            <div class="details">
                <span :title="date">{{ago}}</span> -{{post.domain}} - {{post.num_comments}}
            </div>
        </div>
    </a>
</template>

<script>
    import * as moment from "moment";

    export default {
        props: {post: Object},
        computed: {
            date() {
                return moment.unix(this.post.created_utc).format('YYYY-MM-DD HH:mm')
            },
            ago() {
                return moment.unix(this.post.created_utc).fromNow(false)
            }
        }
    }
</script>

<style lang="scss" scoped>
    .wrapper {
        display: grid;
        grid-template-columns: auto 1fr;
        background: #37373b;
        color:white;

        .score {
            align-self: center;
            text-align: center;
            width: 50px;
        }

        margin: 1em 0;
        box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.4);
        border-radius: 2px;
        text-shadow: none;
    }

    .body {
        background: #444;
        padding: .5em;

        .title {
            font-size: 1.2em;
            font-weight: bold;
        }

        .poster {
            margin-top: .5em;
            color: rgba(250, 250, 250, 0.6);
            a{
                opacity: .6;
                &:hover{
                    opacity: 1;
                }
            }
        }

        .details {
            margin-top: .2em;
            color: rgba(250, 250, 250, 0.6);
        }
    }
</style>
